<template>
  <v-sheet rounded="lg">
    <v-container>
      <h1>
        Vorlage
        <!-- <v-icon class="float-right">mdi-delete</v-icon> -->
      </h1>
      <v-row>
        <v-col> <v-text-field label="Titel" hint="Titel der Terminvorlage" v-model="form.summary" /> </v-col
      ></v-row>
      <v-row>
        <v-col>
          <v-textarea type="text" label="Beschreibung" rows="2" v-model="form.description"></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6"><v-text-field type="time" label="Beginn" v-model="form.start"></v-text-field></v-col>
        <v-col cols="6"><v-text-field type="time" label="Ende" v-model="form.end"></v-text-field> </v-col>
      </v-row>
      <v-row>
        <v-col><v-text-field label="Ort" placeholder="Straße, Ort" hint="Ort der Terminvorlage" v-model="form.location" /></v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            type="number"
            label="Erinnerung"
            v-model="form.reminders.overrides[0].minutes"
            suffix="Minuten"
            min="5"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="text-subtitle-1">
        <v-col
          >Teilnehmer
          <v-icon class="float-right" @click="addAttendee()">mdi-account-plus</v-icon>
        </v-col>
      </v-row>
      <v-row v-for="(attendee, i) in form.attendees" :key="i">
        <v-col>
          <v-text-field
            type="email"
            label="Email"
            placeholder="foo@bar.com"
            v-model="attendee.email"
            append-outer-icon="mdi-delete"
            @click:append-outer="deleteAttendee(i)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn class="secondary" @click="$emit('cancel')">abrechen</v-btn>
          <v-btn class="primary float-right" @click="$emit('save', index, form)">speichern</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  props: ["form", "index"],
  methods: {
    deleteAttendee(index) {
      console.debug(`delete attendee with index ${index}`);
      this.form.attendees.splice(index, 1);
    },
    addAttendee() {
      this.form.attendees.push({ email: "" });
    },
  },
};
</script>

<style></style>
